export default "__VITE_ASSET__C_xt06bK__"